import type { ChangeEvent, FC } from "react";
import { useRef, useState } from "react";
import { Button } from "@mui/material";

interface Props {
  readonly onUpload: (file: File) => Promise<void>;
}

const ACCEPTED_FILE_TYPES = ".xlsx";

const UploadParticipantListButton: FC<Props> = ({ onUpload }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleClick = async () => {
    inputRef.current?.click();
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    setIsUploading(true);
    try {
      await onUpload(file);
    } finally {
      setIsUploading(false);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_FILE_TYPES}
        style={{ display: "none" }}
        onChange={handleFileChange}
        data-testid="upload-participant-list-input"
      />
      <Button onClick={handleClick} disabled={isUploading} variant="outlined" color="secondary">
        Importuj z pliku
      </Button>
    </>
  );
};

export default UploadParticipantListButton;
